"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderRows = orderRows;
function orderRows(used, col, edges, nCols) {
    const cols = Array.from({ length: nCols }, () => []);
    for (const b of used) {
        cols[col.get(b.id) ?? 0].push(b.id);
    }
    const maxRows = Math.max(...cols.map((c) => c.length));
    const slot = new Map();
    const recenter = (c) => {
        const start = Math.floor((maxRows - c.length) / 2);
        c.forEach((id, i) => slot.set(id, start + i));
    };
    cols.forEach(recenter);
    const nbrs = new Map();
    for (const e of edges) {
        const la = nbrs.get(e.a) ?? [];
        la.push(e.b);
        nbrs.set(e.a, la);
        const lb = nbrs.get(e.b) ?? [];
        lb.push(e.a);
        nbrs.set(e.b, lb);
    }
    for (let it = 0; it < 10; it++) {
        for (const c of it % 2 === 1 ? [...cols].reverse() : cols) {
            const bary = (id) => {
                const ns = (nbrs.get(id) ?? []).filter((n) => slot.has(n));
                return ns.length > 0 ? ns.reduce((s, n) => s + (slot.get(n) ?? 0), 0) / ns.length : (slot.get(id) ?? 0);
            };
            c.sort((x, y) => bary(x) - bary(y) || (slot.get(x) ?? 0) - (slot.get(y) ?? 0));
            recenter(c);
        }
    }
    return { slot, maxRows };
}
//# sourceMappingURL=order-rows.js.map